<template>
    <TagSelectorDropdown
        :tags="mergedTags"
        :selected-tags="value"
        :loading="loading"
        :disabled="disabled"
        @select="onSelect"
        @create-tag="onCreateTag"
    />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { ClientTag } from '@evidentid/tprm-portal-lib/models/activity-history';
    import { OperationStatus } from '@evidentid/vue-commons/store/OperationStatus';

    import TagSelectorDropdown
        from '@/modules/entity-tags/components/TagSelectorDropdown/TagSelectorDropdown.vue';
    import { useEntityTagsStore } from '@/modules/entity-tags/store';

    export default defineComponent({
        name: 'TagSelector',
        components: { TagSelectorDropdown },
        props: {
            rpName: {
                type: String as PropType<string>,
                required: true,
            },
            resourceType: {
                type: String as PropType<'NOTE' | 'DOCUMENT'>,
                required: true,
            },
            value: {
                type: Array as PropType<string[]>,
                default: (): string[] => [] as string[],
            },
            disabled: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'input' ],
        data() {
            return {
                localTags: [] as ClientTag[],
            };
        },
        computed: {
            storeTags(): ClientTag[] {
                return useEntityTagsStore().tagsStatus[this.rpName]?.tags?.[this.resourceType] || [];
            },
            mergedTags(): ClientTag[] {
                const storeLabels = new Set((this.storeTags).map((t) => t.label));
                const extraLocal = this.localTags.filter((t) => !storeLabels.has(t.label));
                return [ ...this.storeTags, ...extraLocal ];
            },
            loading(): boolean {
                return useEntityTagsStore().tagsStatus[this.rpName]?.status === OperationStatus.loading;
            },
        },
        created() {
            useEntityTagsStore().loadTags({ rpName: this.rpName });
        },
        methods: {
            onSelect(values: string[]): void {
                this.$emit('input', values);
            },
            onCreateTag(label: string): void {
                if (!this.mergedTags.some((t) => t.label === label)) {
                    (this.localTags as ClientTag[]).push({ key: label, label, isPredefined: false });
                }
            },
        },
    });
</script>
